import React from 'react';

function PaidEducational() {
  return (
    <section className='paidEducational'>
      <p className='scholarships__text'>
        Учреждение не оказывает платных образовательных услуг. Обучение
        слушателей в Учреждении осуществляется на&#8194;
        <span className='scholarships__textUnderline'>
          безвозмездной основе
        </span>
        &#8194;за счет средств бюджета Администрации г. Северодвинска для
        муниципальных организаций, учреждений и предприятий.
      </p>
    </section>
  );
}

export default PaidEducational;
